<div class="fullcontainer">
  <br />
  <br />
  <div class='titleContainer'>
    <h2 class='header'>Bulk Add Inspections</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/workshop/inspections'><i class="fas fa-arrow-left"></i> Back</button>&nbsp;
    </div>
  </div>
  <br />
  @if (this.error) { <div class="alert alert-danger">{{ this.error }}</div> }
  @if (this.result) { <div class="alert alert-success">{{ this.result }}</div> }

  <div class='sheet'>
    <div class="form-row">
      <div class="form-group col-md-4">
        <label>Inspection type *</label>
        <select class="form-control" [(ngModel)]='this.typeId'>
          <option [ngValue]='-1'>Choose an inspection type</option>
          @for (t of this.types; track t.id) { <option [ngValue]='t.id'>{{ t.name }} ({{ this.describeInterval(t) }})</option> }
        </select>
      </div>
      <div class="form-group col-md-3">
        <label>Next due date for all ticked</label>
        <input type="date" class="form-control" [(ngModel)]='this.allDate'>
      </div>
      <div class="form-group col-md-2">
        <label>&nbsp;</label>
        <button class="btn btn-secondary form-control" (click)='this.applyDateToTicked()' [disabled]='!this.allDate || !this.tickedCount()'>Apply</button>
      </div>
      <div class="form-group col-md-3">
        <label>Find a vehicle</label>
        <input type="search" class="form-control" [(ngModel)]='this.search' placeholder="Registration, make or model">
      </div>
    </div>

    <table class='table table-sm table-hover'>
      <thead>
        <tr><th></th><th>Vehicle</th><th>Make / model</th><th>Next due date</th></tr>
      </thead>
      <tbody>
        @for (row of this.visibleRows(); track row.vehicleId) {
          <tr>
            <td><input type="checkbox" [(ngModel)]='row.ticked'></td>
            <td>{{ row.registration }}</td>
            <td>{{ row.description }}</td>
            <td><input type="date" class="form-control form-control-sm" [(ngModel)]='row.nextDueDate' (change)='row.ticked = true'></td>
          </tr>
        }
      </tbody>
    </table>

    <button class='btn btn-secondary' (click)='this.save()' [disabled]='this.busy'>
      <i class='fas fa-save'></i> Add to {{ this.tickedCount() }} vehicle(s)
    </button>
  </div>
</div>
